export default __webpack_public_path__ + "static/media/3.73fb2279.png";